import {
    array,
    boolean,
    nullable,
    number,
    object,
    optional,
    string,
} from "superstruct";

export const CustomerInfoSchema = object({
    id: nullable(number()),
    email: nullable(string()),
    firstName: optional(nullable(string())), // TODO: Remove optional
    lastName: optional(nullable(string())), // TODO: Remove optional
    isB2b: optional(boolean()),
    tags: array(string()),
    company: optional(
        nullable(
            object({
                id: number(),
            })
        )
    ), // TODO: Remove optional
});
